import React, { useEffect, useState } from "react";
import PretendardText from "../../../../components/atoms/text/pretendardText";
import ArticleCard from "../../../../components/templates/articleCard";
import useDisplay from "../../../../hooks/useDisplay";

import "swiper/css";
import "../../../../styles/swiper.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { langState } from "../../../../store/langState";
import { useRecoilValue } from "recoil";
import { apiSDKService } from "../../../../api/renewal/api.service";
import moment from "moment/moment";
import ArticleCardSkeleton from "../../../(v1)/cyber-relation/ArticleCardSkeleton";

const News = () => {
  const { isMobile, isTablet } = useDisplay();
  const isSmall = isMobile || isTablet;
  const [news, setNews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isServerError, setIsServerError] = useState(false);

  const langValue = useRecoilValue(langState);

  useEffect(() => {
    const getPressReleasesAPI = async () => {
      try {
        setIsLoading(true);
        const response = await apiSDKService.getPressReleases(
          1,
          6,
          undefined,
          undefined,
          langValue
        );
        setNews(response.items);
        setIsServerError(false);
      } catch (e) {
        console.error(e);
        setIsServerError(true);
      } finally {
        setIsLoading(false);
      }
    };

    getPressReleasesAPI();
  }, [langValue]);

  if (isServerError) {
    return (
      <PretendardText
        style={{
          fontSize: "15px",
          fontWeight: 400,
          lineheight: "140%",
          color: "#adb4ba",
          marginTop: isMobile ? "80px" : "72px",
        }}
      >
        뉴스 정보를 불러오는 중 오류가 발생했습니다.
      </PretendardText>
    );
  }

  if (isLoading) {
    return (
      <div
        style={{
          width: "100%",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: isMobile ? "center" : "flex-start",
        }}
      >
        {!isMobile && (
          <div className="home-news-swiper-btn swiper-button-prev" />
        )}
        <div
          style={{
            flex: isMobile ? "none" : 1,
            maxWidth: isMobile ? "335px" : "100%",
            width: isMobile ? "335px" : "auto",
            display: "flex",
            flexDirection: "row",
            gap: isMobile ? "20px" : "40px",
          }}
        >
          {Array(isSmall ? 1 : 2)
            .fill(null)
            .map((_, index) => (
              <ArticleCardSkeleton key={index} />
            ))}
        </div>
        {!isMobile && (
          <div className="home-news-swiper-btn swiper-button-next" />
        )}
      </div>
    );
  }

  return (
    <>
      {news.length > 0 ? (
        <div
          style={{
            width: "100%",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: isMobile ? "center" : "flex-start",
          }}
        >
          {!isMobile && (
            <div className="home-news-swiper-btn swiper-button-prev" />
          )}
          <div
            style={{
              flex: isMobile ? "none" : 1,
              maxWidth: isMobile ? "335px" : "100%",
              width: isMobile ? "335px" : "auto",
            }}
          >
            <Swiper
              spaceBetween={isMobile ? 20 : 40}
              slidesPerView={isSmall ? 1 : 2}
              width={isMobile ? 335 : undefined}
              loop={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              navigation={
                !isMobile
                  ? {
                      prevEl: ".home-news-swiper-btn.swiper-button-prev",
                      nextEl: ".home-news-swiper-btn.swiper-button-next",
                    }
                  : false
              }
              modules={[Autoplay, Navigation]}
              className={`home-news ${
                isMobile ? "mobile-home-news" : "custom-cursor"
              }`}
            >
              {news.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    <ArticleCard
                      style={{ width: isMobile ? "335px" : "560px" }}
                      src={item.fileUrl}
                      author={item.mediaCompany}
                      date={moment.utc(item.date).format("YYYY/MM/DD")}
                      title={item.title}
                      link={item.link}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
          {!isMobile && (
            <div className="home-news-swiper-btn swiper-button-next" />
          )}
        </div>
      ) : (
        <PretendardText
          style={{
            fontSize: "15px",
            fontWeight: 400,
            lineheight: "140%",
            color: "#adb4ba",
            marginTop: isMobile ? "80px" : "72px",
          }}
        >
          There are no registered posts.
        </PretendardText>
      )}
    </>
  );
};

export default News;
